
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { mapState } from 'vuex'
import { setToken, getToken, clog, getUrlKey} from "@/common/js/common";
import axios from 'axios';

export default {
name: 'app',
data () {
return {
appClass: '',
bodyPaddingTop: ____hasHeader ? '50px' : '0',
bodyPaddingBottom: '0px',
isFullBuleBg:
this.$router.name === this.$routerNames.OrderInvoiceDetail ||
this.$router.name === this.$routerNames.InvoiceDetail
};
},
components: {
Loading,
XHeader,
TransferDom,
Tabbar,
TabbarItem,
ViewBox
},
directives: {
TransferDom
},
mounted () {
var $self = this;
$self.appClass = ____hasHeader ? 'has-header' : '';
},
computed: {
...mapState({
isLoading: state => state.common.isLoading,
direction: state => state.common.direction
}),
viewTransition() {
var $self = this;
if (!$self.direction) return '';
return (
'vux-pop-' +
('xxxx' === $self.direction
? 'xxxx'
: $self.direction === 'forward' ? 'in' : 'out')
);
}
}
};



// WEBPACK FOOTER //
// ./src/App.vue